import jsonxml from "jsontoxml";
const formatType = {
	jsonToText(data, title) {
		let text = JSON.stringify(data);
		let filename = title;
		let element = document.createElement("a");
		element.setAttribute("href", "data:application/json;charset=utf-8," + encodeURIComponent(text));
		element.setAttribute("download", filename);

		element.style.display = "none";
		document.body.appendChild(element);

		element.click();
		document.body.removeChild(element);
	},
	jsonToJson(data, title) {
		let text = JSON.stringify(data);
		let filename = title;
		let element = document.createElement("a");
		element.setAttribute("href", "data:application/json;charset=utf-8," + encodeURIComponent(text));
		element.setAttribute("download", filename);

		element.style.display = "none";
		document.body.appendChild(element);

		element.click();
		document.body.removeChild(element);
	},
	jsonToXml(data, title) {
		let xml = jsonxml({node: title, parent: data});
		let filename = "CDR Data Usage By Day.xml";
		let element = document.createElement("a");
		element.setAttribute("href", "data:application/json;charset=utf-8," + encodeURIComponent(xml));
		element.setAttribute("download", filename);

		element.style.display = "none";
		document.body.appendChild(element);

		element.click();
		document.body.removeChild(element);
	},
};

export default formatType;
